import React, { Component } from 'react';
import SiteLoader from '../layout/site-loader';
import { connect } from 'react-redux'
import { Link } from 'react-router-dom';
import ArrowButton from '../common/button-arrow';
import { getHomePage } from "../../actions/home";
import { Col } from 'react-bootstrap';
import PageTitle from '../common/page-title/index';
import BannerCarousel from './banner-carousel/banner-carousel';
import LatestNews from './latest-news/latest-news';
import BrandCarousel from './brand-carousel';
import Order from './order/order';
import { checkPermission } from '../common/guards/can';

import './styles.css';

class HomePage extends Component {
  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(getHomePage());
  }

  render() {
    const { showPrivacyPopup, viewConfigLoaded, carousels, loading, loaded, carousel_speed, hasRewardOutlet } = this.props;

    if (!viewConfigLoaded || loading || showPrivacyPopup) {
      return <SiteLoader />;
    }

    return (
      <div>
        <Col md={12}>
          <PageTitle pageTitle='Home' />
        </Col>
        {(this.props.viewConfigLoaded && loaded) &&
          <div>
            <div className="home-slide">
              <BannerCarousel carousels={carousels} carouselSpeed={carousel_speed} />
            </div>
            <div className="home-page-spacer">
              <BrandCarousel />
            </div>
            <div className="home-page-spacer">
              <div className='container my-rewards-link'>
                <Link to={'/my-rewards'}>
                  <ArrowButton arrow={false} color='red' submit={false}>
                    Click Here to Redeem points
                  </ArrowButton>
                </Link>
              </div>
            </div>
            <div className="home-page-spacer">
              <LatestNews />
            </div>
          </div>}
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    viewConfigLoaded: state.viewConfig.loaded,
    showPrivacyPopup: state.viewConfig.showPrivacyPopup,
    carousels: state.home.home_carousels,
    loaded: state.home.fetched,
    loading: state.home.fetching & !state.home.fetched,
    carousel_speed: state.home.carousel_speed,
    hasRewardOutlet: state.viewConfig.profile.attributes['has-reward-outlet']
  };
};

export default connect(mapStateToProps)(HomePage);



// WEBPACK FOOTER //
// ./src/components/home/home-page.jsx